import React from 'react';
import WeighingInterface from '@/components/WeighingInterface';

const WeighingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <WeighingInterface />
    </div>
  );
};

export default WeighingPage;
